const REF_STORAGE_KEY = "padpulse_ref";

export function getStoredReferralCode(): string | null {
  try {
    const v = localStorage.getItem(REF_STORAGE_KEY);
    return v && v.trim() ? v.trim() : null;
  } catch {
    return null;
  }
}

export function clearStoredReferralCode(): void {
  try {
    localStorage.removeItem(REF_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

// Reads ?ref=<code> from the current URL. When present it persists the code for
// later signup attribution and fires a fire-and-forget click ping so the
// affiliate's dashboard can show "click stats". Safe to call on every mount —
// it no-ops when there is no ref param. Never throws.
export function captureReferralFromUrl(): void {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("ref");
    if (!code || !code.trim()) return;
    const trimmed = code.trim().slice(0, 128);

    localStorage.setItem(REF_STORAGE_KEY, trimmed);

    fetch("/api/referral-clicks", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ ref: trimmed, path: window.location.pathname }),
      keepalive: true,
    }).catch(() => {
      /* tracking must never break the page */
    });
  } catch {
    /* ignore */
  }
}
